module.exports = "https://cdn.hellotech.com/client-assets/twitter_16271dbb527d17343b17a4c6705732b9.svg";